<template>
	<div>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="containerItem">
				<div class="top">
					<span class="image" :lazy-background='item.img'></span><div class="header">{{item.header}}</div>
				</div>
				<div class="bottom">
					<div class="text">
						{{item.text}}
					</div>
					<div class="more">
						<!--<a href="javascript: void(0)" class="more-svg">-->
							<!--<svg width="16px" height="16px">-->
								<!--<use xlink:href="#svg-clock"></use>-->
							<!--</svg>-->
							<!--<span v-if="item.timer.text">-->
								<!--завершена-->
							<!--</span>-->
						<!--</a>-->
						<a :href="item.href" class="button waves-effect waves-light">
							{{item.button}}
						</a>
						<span v-if="item.price" v-html="item.price" class="price"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
		<!--<div class="all-tours">-->
			<!--<a href="javascript:void(0)">-->
				<!--Дивитися всі тури-->
			<!--</a>-->
		<!--</div>-->
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {
			// priceFormat: window.priceFormat
			// items: this.changeArrayPrice
		}
	},
	//  computed: {
	// 	changeArrayPrice: function() {
	// 		let items = this.items.map(function(element) {
	// 			if(element.price){
	// 				element.price = priceFormat(+element.price);
	// 			}
	// 			return element;
	// 		});
	// 		return items;
	// 	},
	// },
	updated() {
		
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 3 ? true : false,
				nav: true,
				dots: true,
				margin: 30,
				responsive: {
					0: {
						items: 1,
					},
					1024: {
						items: 2,
					},
					1180: {
						items: 3,
					}
				}
			}
		});
	},
	mounted() {
		lazyBackground();
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.catalogVueslider{
	.slider-catalogVueslider{
		.more{
			.button{
				margin-left: 0px;
			}
			.price{
				font-weight: 900;
				font-size: 0.875rem;
				color: #000000;
			}			
		}
	}	
}
.all-tours a{
	color: #de4b39;
	text-decoration: none;
	text-decoration-color: #de4b39;
}
.all-tours{
	text-align: right;
	margin-top: 20px;
}
.all-tours:hover{
	text-decoration: underline;
	text-decoration-color: #de4b39;
}

.slider-catalogVueslider {
	.more{
		display: inline-flex;
		align-items: center;
		margin-top: 30px;
		justify-content: space-between;
		width: 100%;
		padding-left: 30px;
		padding-right: 30px;
		svg{
			margin-right: 3px;
		}
		.button{
			margin-left: 10px;
		}
		.more-svg{
			display: inline-flex;
			align-items: center;
			font-size: 0.75rem;
			color: #444a4e;
			text-decoration: none;
		}
	}
	/*padding-bottom: 72px;*/
	.owl-carousel {
		padding: 0 2px;
		position: relative;
		padding-bottom: 70px;
		.item {
			padding-right: 1px;
			.containerItem{
				.image{
					width: 62px;
					height: 62px;
					max-width: 62px;
					min-width: 62px;
					display: inline-flex;
					border: 1px solid black;
					border-radius: 50%;
					background-size: 29px 29px;
					background-repeat: no-repeat;
					background-position: center;
				}
				.top{
					display: flex;
					justify-conent: center;
					align-items: center;
					border: 1px solid #e2edf3;
					box-shadow: 0px -3px 2px #e2edf3;
					border-bottom: 2px dotted #eaf1f6;
					border-radius: 5px;
					position: relative;
					z-index: 11;
					height: 130px;
					align-items: center;
					.image{
						margin-right: 20px;
						margin-left: 30px;
						margin-right: 30px;
					}
					.header{
						max-width: 150px;
						font-weight: 900;
						font-size: rem(15);
						line-height: rem(24);
						max-height: rem(96);
						overflow: hidden;
						color: black;
					}
				}
				.bottom{
					border: 1px solid #e2edf3;
					box-shadow: 0px 0px 2px #e2edf3;
					border-radius: 5px;
					position: relative;
					top: -1px;
					z-index: 0;
					padding-bottom: 30px;
					&:after{
						content: "";
						width: 98%;
						position: absolute;
						top: -2px;
						left: 3px;
						right: 0;
						height: 2px;
						background: #fff;
					}
				}
				.text{
					padding-top: 22px;
					padding-left: 30px;
					padding-right: 30px;
					line-height: rem(20);
					height: rem(82);
					overflow: hidden;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// catalogVueslider.vue?52cc2703